// extracted by mini-css-extract-plugin
export default {"parent":"Bottom_parent__O7Gel","childwala":"Bottom_childwala__DncBe","h1s":"Bottom_h1s__LwnoI","strongs":"Bottom_strongs__wwPzx","buttons":"Bottom_buttons__aTb-S"};